'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('gallery-show', {
      url: '/gallery/:id',
      template: '<gallery-show></gallery-show>',
      authenticate: true
    })
    .state('public-gallery-show', {
      url: '/public/gallery/:id',
      template: '<gallery-show public="true"></gallery-show>'
    });
}



// WEBPACK FOOTER //
// ./client/app/gallery/show/gallery-show.routes.js